import { MainNotificationDto } from "@closerplatform/spinner-openapi";
import {
  getLanguageOptionWithDefault,
  getLanguageOption,
  LanguageOption
} from "@fidget/common/components/form/languagePicker/languagePicker";
import { FieldState, FormState } from "formstate";
import { MainNotificationForm, MainNotificationFormFields } from "./types";

const mapMainNotificationDtoToForm = (dto: MainNotificationDto): MainNotificationForm => {
  return new FormState<MainNotificationFormFields>({
    id: new FieldState(dto.id),
    enabled: new FieldState(dto.enabled),
    locale: new FieldState(getLanguageOptionWithDefault(dto.locale)),
    text: new FieldState(dto.text)
  });
};

const createEmptyForm = (locale: LanguageOption): MainNotificationForm => {
  return new FormState<MainNotificationFormFields>({
    id: new FieldState(""),
    enabled: new FieldState<boolean>(false),
    locale: new FieldState(locale),
    text: new FieldState("")
  });
};

export const createMainNotificationForms = (
  dtos: MainNotificationDto[]
): MainNotificationForm[] => {
  const dtoPl = dtos.find((d) => getLanguageOption(d.locale) === LanguageOption.Polish);
  const dtoEn = dtos.find((d) => getLanguageOption(d.locale) === LanguageOption.English);

  const formPl = dtoPl && mapMainNotificationDtoToForm(dtoPl);
  const formEn = dtoEn && mapMainNotificationDtoToForm(dtoEn);

  return [
    formPl || createEmptyForm(LanguageOption.Polish),
    formEn || createEmptyForm(LanguageOption.English)
  ];
};
